import { cloneConfig, validateOfferEditor } from './commonEditorModel';
import { numberFromInput, serializeSharedProductFields } from './editorProductFields';

export const validateInternetEditor = (values = {}) => {
    const errors = validateOfferEditor(values, {
        priceFields: [
            'belowLinePrice',
            'aboveLinePrice',
            'mobilityBelowLinePrice',
            'mobilityAboveLinePrice',
            'eppMobilityBelowLinePrice',
            'eppMobilityAboveLinePrice',
            'pabAdjustmentAmount',
            'emailRegularPrice'
        ]
    });
    const tvAdjustmentAmount = Number(values.tvPriceAdjustment?.amount);
    if (values.tvPriceAdjustment?.enabled && (!Number.isFinite(tvAdjustmentAmount) || tvAdjustmentAmount < 0)) {
        errors.push('Temporary TV price adjustment amount must be a non-negative number.');
    }
    return errors;
};

export const serializeInternetEditor = (sourceConfig, editor, archivedAt) => {
    const nextConfig = cloneConfig(sourceConfig);
    const products = nextConfig.products.internet || [];
    const index = products.findIndex((product) => product.id === editor.originalId);
    if (index === -1 && !editor.isNew) {
        throw new Error('Unable to find the selected Internet product in the draft config.');
    }

    const values = editor.values;
    const previous = index === -1 ? {} : products[index];
    const nextProduct = {
        ...previous,
        id: editor.originalId,
        displayName: values.displayName.trim(),
        belowLinePrice: numberFromInput(values.belowLinePrice),
        aboveLinePrice: values.aboveLinePrice === '' ? null : numberFromInput(values.aboveLinePrice),
        mobilityBelowLinePrice: numberFromInput(values.mobilityBelowLinePrice),
        mobilityAboveLinePrice: values.mobilityAboveLinePrice === '' ? null : numberFromInput(values.mobilityAboveLinePrice),
        eppMobilityBelowLinePrice: numberFromInput(values.eppMobilityBelowLinePrice),
        eppMobilityAboveLinePrice: values.eppMobilityAboveLinePrice === '' ? null : numberFromInput(values.eppMobilityAboveLinePrice),
        pabAdjustmentAmount: numberFromInput(values.pabAdjustmentAmount),
        emailRegularPrice: values.emailRegularPrice === '' ? null : numberFromInput(values.emailRegularPrice),
        mobilityDiscountEligible: Boolean(values.mobilityDiscountEligible),
        eppEligible: Boolean(values.eppEligible),
        recommended: Boolean(values.recommended),
        hot: Boolean(values.hot),
        highlightNote: values.highlightNote.trim(),
        ...serializeSharedProductFields(values, previous, archivedAt),
        tvPriceAdjustment: {
            enabled: Boolean(values.tvPriceAdjustment?.enabled),
            amount: values.tvPriceAdjustment?.enabled ? numberFromInput(values.tvPriceAdjustment?.amount) : 0,
            label: String(values.tvPriceAdjustment?.label || '').trim()
        }
    };

    if (index === -1) {
        products.push(nextProduct);
    } else {
        products[index] = nextProduct;
    }
    nextConfig.products.internet = products;
    return nextConfig;
};
